/* eslint-disable react/jsx-props-no-spreading */
/* eslint react/prop-types: 0 */
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';

const LienheBackground = 'https://static.chinhdaisteel.com/quality_certification/bg_contact_new.webp';
const styles = (theme) => ({
  root: {
    backgroundPosition: 'right',
    display: 'flex',
    alignItems: 'center',
    backgroundBlendMode: 'overlay',
    backgroundColor: '#444',
    marginBottom: theme.spacing(10),
    backgroundImage: `url(${LienheBackground})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
  },
  button: {
    backgroundColor: '#3f51b5',
    fontFamily: [
      'Roboto', 'Helvetica Neue', 'Arial',
    ].join(','),
    margin: 'auto',
    [theme.breakpoints.down('sm')]: {
      marginLeft: '2rem',
      fontSize: '1rem',
      paddingTop: '1rem',
      paddingBottom: '1rem',
    },
    [theme.breakpoints.up('md')]: {
      marginLeft: '6rem',
      fontSize: '1.14rem',
      paddingTop: '1rem',
      paddingBottom: '1rem',
      paddingLeft: '0.6rem',
      paddingRight: '0.6rem',
      borderRadius: 4,
      width: '20%',
    },
  },
  title: {
    [theme.breakpoints.up('md')]: {
      marginTop: '6rem',
    },
    fontWeight: 'bold',
    fontSize: '2rem',
    color: 'white',
  },
  subTitle: {
    fontFamily: [
      'Roboto', 'Helvetica', 'Arial', 'san-serif',
    ].join(','),
    color: 'white',
    fontSize: '1.33rem',
    paddingTop: '1rem',
  },
  container: {
    height: '40vh',
    marginTop: '25vh',
  },
});

function Contact(props) {
  const { classes } = props;

  return (
    <section className={classes.root}>
      <Container className={classes.container} maxWidth="lg">
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="h4" marked="center" align="center" component="h2" className={classes.title}>
              LIÊN HỆ VỚI CÔNG TY TNHH CÔNG NGHIỆP CHÍNH ĐẠI
            </Typography>
            <Typography align="center" className={classes.subTitle}>
              Hãy liên lạc với chúng tôi để nhận được tư vấn, báo giá
              cho các sản phẩm giải pháp tốt nhất
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </section>
  );
}

export default withStyles(styles)(Contact);
